module.exports = __webpack_public_path__ + "static/media/data-analysis.d9ef995c.svg";